import axios from '../utils/axios';

export default function bulkReject(adminId, data) {
    return axios.post('/admin/' + adminId + '/bulk-reject', data);
}